<template>
  <div class="atelier-page">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h1 class="mb-1">Atelier</h1>
        <p class="text-muted mb-0">Informations de votre atelier</p>
      </div>
      <button class="btn btn-primary" @click="$router.push({name:'atelier.edit'})">
        Modifier
      </button>
    </div>

    <div v-if="hasTenant">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Informations de l'atelier</h5>
          <dl class="row">
            <template v-for="(key, idx) in keysToPrint" :key="idx+'tenant_info'">
            
              <dt class="col-sm-4 text-capitalize" v-if="tenant[key]">{{ formatField(key) }}</dt>
              <dd class="col-sm-8" v-if="tenant[key]">{{ formatValue(tenant[key]) }}</dd>
            </template>
          </dl>
        </div>
      </div>
    </div>

    <div v-else class="alert alert-info">
      Chargement des informations de l'atelier...
    </div>
  </div>
</template>

<script>
import { useUserStore } from "@/store/userStore";
import { fetchTenant } from "@/helpers/userMethods";

export default {
  name: "Atelier",
  computed: {
    userStore() {
      return useUserStore();
    },
    tenant() {
      return this.userStore.tenant || {};
    },
    hasTenant() {
      return Object.keys(this.tenant).length > 0;
    },
  },
  data:()=>({
    keysToPrint:[
        'name',
        'code',
        'address',
        'city',
        'phone',
        'email',
        'website',
        'facebook',
    ]
  }),
  methods: {
    formatField(value) {
      return value.replace(/_/g, " ");
    },
    formatValue(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      if (typeof value === "object") {
        return JSON.stringify(value);
      }
      return value;
    },
    loadTenantInfo() {
      this.userStore.loadTenant();
      fetchTenant.call(this);
    },
  },
  created() {
    this.loadTenantInfo();
  },
};
</script>
